<template>
  <div>
    <label for="email" class="block text-sm font-medium text-gray-700">{{ title }}</label>
    <div class="mt-1 relative rounded-md shadow-sm" :class="error && 'text-red-600'">
      <select v-model.trim="$v.newValue.$model" type="email" name="email" id="email" class="focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md" :class="error && 'focus:!ring-red-600 !border-red-600'">

        <option
          v-for="val in options"
          :key="val.id"

          :value="val.id"
        >
          {{ val.label }}
        </option>
      </select>
      <span v-if="error">Invalid number</span>
    </div>
  </div>
</template>

<script>

import fieldHelper from "@/components/SideEditor/BlockConfigurationTabs/FormList/field-helper"

export default {
  mixins: [fieldHelper],
  validations: {
    newValue: {  },
  },
}

</script>
